import { z } from 'zod/v4';

import { authenticatedUserSchema } from '../../../schemas/authenticated-user.schema';

export const switchedAccountUserSchema = authenticatedUserSchema
  .extend({
    userBelongsToAccount: z.boolean(),
  })
  .omit({
    forcePasswordReset: true,
  });

export type SwitchedAccountUser = z.infer<typeof switchedAccountUserSchema>;
